import { render, staticRenderFns } from "./TimeLimitSettings.vue?vue&type=template&id=5b38945e&scoped=true"
import script from "./TimeLimitSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeLimitSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TimeLimitSettings.vue?vue&type=style&index=0&id=5b38945e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38945e",
  null
  
)

export default component.exports